<div class="main-content background container_password">
  <div class="flex justify-between items-center">
    <h3 class="tam-title">ALTERAR SENHA</h3>
    <div class="button-close">
      <i class="material-icons hover-close" (click)="closeCancel()">close</i>
    </div>
  </div>

  <div class="card">
    <form [formGroup]="passwordForm">
      <div class="form-group relative">
        <div class="input-container" 
             [class.invalid]="passwordForm.get('currentPass').invalid && (passwordForm.get('currentPass').touched || viewError)">
          <input type="password" placeholder="Senha atual" formControlName="currentPass" id="cp" class="input-style">
          <i (click)="showPassword('cp')" class="material-icons custom-icon-view-pass-absolute" id="cpicon">visibility</i>
        </div>
        <div *ngIf="passwordForm.get('currentPass').hasError('required') && viewError" class="error-message">
          Senha atual <strong>é obrigatório!</strong>
        </div>
        <div *ngIf="passwordForm.get('currentPass').hasError('minlength')" class="error-message">
          Mínimo de 8 caracteres
        </div>
      </div>
      <div class="form-group relative">
        <div class="input-container" 
             [class.invalid]="passwordForm.get('newPass').invalid && (passwordForm.get('newPass').touched || viewError)">
          <input type="password" placeholder="Nova senha" formControlName="newPass" id="np" onpaste="return false;" class="input-style">
          <i (click)="showPassword('np')" class="material-icons custom-icon-view-pass-absolute" id="npicon">visibility</i>
        </div>
        <div *ngIf="passwordForm.get('newPass').hasError('required') && viewError" class="error-message">
          Nova senha <strong>é obrigatório!</strong>
        </div>
        <div *ngIf="passwordForm.get('newPass').hasError('minlength')" class="error-message">
          Mínimo de 8 caracteres
        </div>
      </div>
      <div class="form-group relative" *ngIf="passwordForm.get('newPass').dirty || passwordForm.get('newPass').touched">
        <div class="input-container" 
             [class.invalid]="(passwordForm.get('confirmNewPass').invalid || passwordForm.errors?.passwordMatch) && 
                             (passwordForm.get('confirmNewPass').touched || viewError)">
          <input type="password" placeholder="Confirmar nova senha" formControlName="confirmNewPass" id="cnp" onpaste="return false;" class="input-style">
          <i (click)="showPassword('cnp')" class="material-icons custom-icon-view-pass-absolute" id="cnpicon">visibility</i>
        </div>
        <div *ngIf="passwordForm.get('confirmNewPass').hasError('required') && viewError" class="error-message">
          Confirmar nova senha <strong>é obrigatório!</strong>
        </div>
        <div *ngIf="passwordForm.errors?.passwordMatch" class="error-message">
          Senhas <strong>não conferem!</strong>
        </div>
      </div>

      <!-- ALTERADO AQUI: Só mostra os requisitos se o campo tiver valor -->
      <div class="password-feedback"
           *ngIf="(passwordForm.get('newPass').dirty || passwordForm.get('newPass').touched) && passwordForm.get('newPass').value">
        <div class="feedback-title">Sua senha deve ter:</div>
        <div *ngIf="passwordForm.get('newPass').invalid; else validPassword">
          <div class="feedback-item"
              [class.valid]="!passwordForm.get('newPass').errors?.numberError"
              [class.invalid]="passwordForm.get('newPass').errors?.numberError">
            <span *ngIf="passwordForm.get('newPass').errors?.numberError">&#9888;</span>
            <span *ngIf="!passwordForm.get('newPass').errors?.numberError">&#10003;</span>
            Pelo menos um número
          </div>
          <div class="feedback-item"
              [class.valid]="!passwordForm.get('newPass').errors?.upperCaseError"
              [class.invalid]="passwordForm.get('newPass').errors?.upperCaseError">
            <span *ngIf="passwordForm.get('newPass').errors?.upperCaseError">&#9888;</span>
            <span *ngIf="!passwordForm.get('newPass').errors?.upperCaseError">&#10003;</span>
            Pelo menos uma letra maiúscula
          </div>
          <div class="feedback-item"
              [class.valid]="!passwordForm.get('newPass').errors?.lowerCaseError"
              [class.invalid]="passwordForm.get('newPass').errors?.lowerCaseError">
            <span *ngIf="passwordForm.get('newPass').errors?.lowerCaseError">&#9888;</span>
            <span *ngIf="!passwordForm.get('newPass').errors?.lowerCaseError">&#10003;</span>
            Pelo menos uma letra minúscula
          </div>
          <div class="feedback-item"
              [class.valid]="!passwordForm.get('newPass').errors?.symbolError"
              [class.invalid]="passwordForm.get('newPass').errors?.symbolError">
            <span *ngIf="passwordForm.get('newPass').errors?.symbolError">&#9888;</span>
            <span *ngIf="!passwordForm.get('newPass').errors?.symbolError">&#10003;</span>
            Pelo menos um caractere especial
          </div>
          <div class="feedback-item"
              [class.valid]="!passwordForm.get('newPass').errors?.minlength"
              [class.invalid]="passwordForm.get('newPass').errors?.minlength">
            <span *ngIf="passwordForm.get('newPass').errors?.minlength">&#9888;</span>
            <span *ngIf="!passwordForm.get('newPass').errors?.minlength">&#10003;</span>
            Pelo menos 8 caracteres
          </div>
        </div>
        
        <ng-template #validPassword>
          <div class="feedback-item valid">&#10003; Pelo menos um número</div>
          <div class="feedback-item valid">&#10003; Pelo menos uma letra maiúscula</div>
          <div class="feedback-item valid">&#10003; Pelo menos uma letra minúscula</div>
          <div class="feedback-item valid">&#10003; Pelo menos um caractere especial</div>
          <div class="feedback-item valid">&#10003; Pelo menos 8 caracteres</div>
        </ng-template>
      </div>

      <div class="actions">
        <button type="button" (click)="closeCancel()" class="btn cancel">CANCELAR</button>
        <button type="button" (click)="closeConfirm()" class="btn confirm">ALTERAR</button>
      </div>
    </form>
  </div>
</div>